var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mag-grid",class:_vm.cls,style:(_vm.stl)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }